function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientTransform: "matrix(1 0 0 -1 -561.6 -5522.991)",
  gradientUnits: "userSpaceOnUse",
  x1: 1065.072,
  x2: 582.024,
  y1: -6063.353,
  y2: -5508.298
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff3ee",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2938,
  stopColor: "#ffeade",
  stopOpacity: 0.373
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7874,
  stopColor: "#ffd6bb"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 253,
  x2: 253,
  y1: 454.666,
  y2: 49.306
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff4d4d",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff4d4d",
  stopOpacity: 0
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m500.574 200.6c7.18-16.204 11.241-34.098 11.419-52.921.684-71.971-56.211-132.099-128.121-135.166-23.591-1.006-45.905 4.091-65.495 13.843-39.321 19.575-85.436 19.575-124.757 0-19.589-9.752-41.903-14.849-65.494-13.843-71.908 3.068-128.803 63.194-128.12 135.166.179 18.823 4.239 36.717 11.419 52.921 15.628 35.269 15.628 75.53 0 110.8-7.18 16.204-11.241 34.099-11.419 52.922-.683 71.972 56.212 132.098 128.122 135.165 23.591 1.006 45.905-4.091 65.494-13.843 39.321-19.575 85.435-19.575 124.755 0 19.589 9.752 41.904 14.849 65.495 13.843 71.909-3.067 128.804-63.194 128.121-135.165-.179-18.823-4.239-36.717-11.419-52.921-15.628-35.271-15.628-75.532 0-110.801z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m410.49 69.306v365.36c0 11.05-8.95 20-20 20h-274.98c-11.05 0-20-8.95-20-20v-365.36c0-11.05 8.95-20 20-20h274.98c11.05 0 20 8.95 20 20z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#4d4dff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m206.64 134.326v114.38c0 5.52-4.48 10-10 10h-19.75l-7.16 14.47c-.75 1.51-1.89 2.74-3.27 3.6-1.38.85-3 1.33-4.68 1.33-3.37 0-6.45-1.91-7.94-4.93l-7.16-14.47h-51.17v-134.38h101.13c5.52 0 10 4.47 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m410.49 284.236v134.38h-95.13c-5.52 0-10-4.47-10-10v-114.38c0-5.52 4.48-10 10-10h19.75l7.16-14.47c.75-1.51 1.89-2.74 3.27-3.6 1.38-.85 3-1.33 4.68-1.33 3.37 0 6.45 1.91 7.94 4.93l7.16 14.47z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m386.49 78.306v347.36c0 2.77-2.24 5-5 5h-59.62c-1.92 0-3.66-1.09-4.5-2.81l-2.5-5.16c-.84-1.72-2.58-2.81-4.5-2.81h-114.74c-1.92 0-3.66 1.09-4.5 2.81l-2.5 5.16c-.84 1.72-2.58 2.81-4.5 2.81h-59.62c-2.76 0-5-2.23-5-5v-347.36c0-2.77 2.24-5 5-5h59.62c1.92 0 3.66 1.09 4.5 2.81l2.5 5.16c.84 1.72 2.58 2.81 4.5 2.81h114.74c1.92 0 3.66-1.09 4.5-2.81l2.5-5.16c.84-1.72 2.58-2.81 4.5-2.81h59.62c2.76 0 5 2.23 5 5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ebebff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m206.64 134.326v114.38c0 5.52-4.48 10-10 10h-19.75l-7.16 14.47c-.75 1.51-1.89 2.74-3.27 3.6-1.38.85-3 1.33-4.68 1.33-3.37 0-6.45-1.91-7.94-4.93l-7.16-14.47h-27.17v-134.38h77.13c5.52 0 10 4.47 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m386.49 284.236v134.38h-71.13c-5.52 0-10-4.47-10-10v-114.38c0-5.52 4.48-10 10-10h19.75l7.16-14.47c.75-1.51 1.89-2.74 3.27-3.6 1.38-.85 3-1.33 4.68-1.33 3.37 0 6.45 1.91 7.94 4.93l7.16 14.47z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m196.635 104.838h-118.93c-5.53 0-10 4.48-10 10v114.38c0 5.52 4.47 10 10 10h68.97l7.164 14.474c1.495 3.021 4.574 4.932 7.944 4.932 3.371 0 6.451-1.913 7.945-4.935l7.157-14.472h19.75c5.523 0 10-4.477 10-10v-114.38c0-5.522-4.477-9.999-10-9.999z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m315.365 399.135h118.93c5.53 0 10-4.48 10-10v-114.38c0-5.52-4.47-10-10-10h-68.97l-7.164-14.474c-1.495-3.021-4.574-4.932-7.944-4.932-3.371 0-6.451 1.913-7.945 4.935l-7.157 14.472h-19.75c-5.523 0-10 4.477-10 10v114.38c0 5.522 4.477 9.999 10 9.999z",
  fill: "#ff6c6c"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m114.853 179.263c-14.954 0-27.12-12.167-27.12-27.121s12.166-27.121 27.12-27.121c14.955 0 27.121 12.166 27.121 27.121s-12.165 27.121-27.121 27.121zm0-44.242c-9.44 0-17.12 7.68-17.12 17.121s7.68 17.121 17.12 17.121 17.121-7.68 17.121-17.121-7.68-17.121-17.121-17.121z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136.914 179.202c-1.279 0-2.56-.488-3.535-1.464l-21.12-21.12c-1.953-1.953-1.953-5.119 0-7.071 1.951-1.952 5.119-1.952 7.07 0l21.12 21.12c1.953 1.953 1.953 5.119 0 7.071-.975.976-2.256 1.464-3.535 1.464z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m452.295 191.28h-3v-3c0-2.761-2.238-5-5-5s-5 2.239-5 5v3h-3c-2.762 0-5 2.239-5 5s2.238 5 5 5h3v3c0 2.761 2.238 5 5 5s5-2.239 5-5v-3h3c2.762 0 5-2.239 5-5s-2.238-5-5-5z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m66.735 345.51h-3v-3c0-2.761-2.238-5-5-5s-5 2.239-5 5v3h-3c-2.762 0-5 2.239-5 5s2.238 5 5 5h3v3c0 2.761 2.238 5 5 5s5-2.239 5-5v-3h3c2.762 0 5-2.239 5-5s-2.238-5-5-5z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61.469 313.342c-1.279 0-2.56-.488-3.535-1.464l-4.465-4.464-4.465 4.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.951-1.952 5.119-1.952 7.07 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.976.976-2.256 1.464-3.535 1.464z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.735 74.09c-1.279 0-2.56-.488-3.535-1.464l-4.465-4.464-4.465 4.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.951-1.952 5.119-1.952 7.07 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.975.975-2.255 1.464-3.535 1.464z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m469.265 158.388c-1.279 0-2.56-.488-3.535-1.464l-4.465-4.464-4.465 4.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.951-1.952 5.119-1.952 7.07 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.976.976-2.256 1.464-3.535 1.464z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m251 331.228c0 2.761 2.238 5 5 5h49.36v-10h-44.36v-153.482c0-2.761-2.238-5-5-5h-49.36v10h44.36z",
  fill: "#b3b3ff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m419.268 378.953c-1.937 0-3.78-1.132-4.595-3.024l-13.827-32.119-13.827 32.119c-1.093 2.537-4.036 3.708-6.57 2.615-2.536-1.092-3.707-4.033-2.615-6.569l18.42-42.787c.79-1.834 2.596-3.023 4.593-3.023s3.803 1.188 4.593 3.023l18.42 42.787c1.092 2.536-.079 5.478-2.615 6.569-.645.277-1.316.409-1.977.409z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m409.198 365.306h-20.897c-2.762 0-5-2.239-5-5s2.238-5 5-5h20.897c2.762 0 5 2.239 5 5s-2.238 5-5 5z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m410.49 69.306v365.36c0 11.05-8.95 20-20 20h-274.98c-11.05 0-20-8.95-20-20v-365.36c0-11.05 8.95-20 20-20h274.98c11.05 0 20 8.95 20 20z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m370.566 149.388h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff9d33"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m370.566 168.891h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff9d33"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m370.566 188.393h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m310.566 207.896h-28.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h28.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m370.566 207.896h-38.176c-2.762 0-5-2.239-5-5s2.238-5 5-5h38.176c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m370.566 227.399h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
}))))), /*#__PURE__*/React.createElement("g", {
  fill: "#8383ff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 352.578,
  cy: 116.857,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 368.828,
  cy: 116.857,
  r: 5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m229.953 302.002h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff9d33"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m229.953 321.505h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff9d33"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m229.953 341.007h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m169.953 360.51h-28.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h28.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m229.953 360.51h-38.176c-2.762 0-5-2.239-5-5s2.238-5 5-5h38.176c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m229.953 380.013h-88.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h88.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff6c6c"
}))))), /*#__PURE__*/React.createElement("g", {
  fill: "#8383ff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 211.965,
  cy: 269.471,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 228.215,
  cy: 269.471,
  r: 5
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m178.553 217.693h-83.766c-2.761 0-5-2.239-5-5v-11.413c0-2.761 2.239-5 5-5h83.767c2.761 0 5 2.239 5 5v11.412c-.001 2.762-2.239 5.001-5.001 5.001z",
  fill: "#ffe8dc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m417.213 307.693h-83.767c-2.761 0-5-2.239-5-5v-11.413c0-2.761 2.239-5 5-5h83.767c2.761 0 5 2.239 5 5v11.412c0 2.762-2.238 5.001-5 5.001z",
  fill: "#fee"
})))));

function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.999 511.999",
    height: 512,
    viewBox: "0 0 511.999 511.999",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.f15eab93.svg";
export { ForwardRef as ReactComponent };